import React, { useState } from 'react';
import { RelatedDocFilter } from './components/RelatedDocFilter/RelatedDocFilter';
import { RelatedDocList } from './components/RelatedDocList';
import { useRelatedDocFilterItems } from './RelatedDocContainer.hooks';
import { RelatedItemTag, RelatedDocumentItem } from '@layouts/Related/Related.types';

interface RelatedDocContainerProps {
  styleType: string;
  content: RelatedDocumentItem[];
  othersLabel: string;
  customTabText: string;
  customTabContent: string;
  I18n: Record<string, string>;
}

export const RelatedDocContainer = ({
  styleType,
  content,
  othersLabel,
  customTabText,
  customTabContent,
  I18n,
}: RelatedDocContainerProps) => {
  const [selectedTag, setSelectedTag] = useState(false);
  const [filterTag, setFilterTag] = useState<RelatedItemTag>({
    id: 0,
    name: 'All',
  });
  const filters = useRelatedDocFilterItems({
    content,
    othersLabel,
    customTabText,
  });

  const updateSelectedTag = (val: boolean) => {
    setSelectedTag(val);
  };

  const updateFilterTag = (newFilterTag: RelatedItemTag) => {
    if (filterTag.id != newFilterTag.id) {
      setSelectedTag(true);
      setFilterTag(newFilterTag);
    }
  };

  return (
    <div className='l-section l-section-100'>
      <RelatedDocFilter tags={filters} i18n={I18n} isBound={true} onTagClick={updateFilterTag} />

      <RelatedDocList
        renderCustomContent={customTabContent}
        items={content}
        i18n={I18n}
        filterTag={filterTag}
        selectedTag={selectedTag}
        updateSelectedTag={updateSelectedTag}
      />
    </div>
  );
};
